import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'

const updateClaimStatus = async (claimFormId: string, claimStatus: string) => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}/status`,
    { status: claimStatus },
  )

  return response.data
}

const useUpdateClaimStatus = () => {
  const mutation = useMutation({
    mutationKey: ['useUpdateClaimStatus'],
    mutationFn: async ({
      claimFormId,
      claimStatus,
    }: {
      claimFormId: string
      claimStatus: string
    }) => updateClaimStatus(claimFormId, claimStatus),
  })

  return mutation
}

export { useUpdateClaimStatus }
